import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "axios";

export const getProduct = createAsyncThunk(
    "product/getClientProduct",
    async (params, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/client/product`);
            // console.log(response);
            if(response.data.sucess){
                return response.data.data;
            }else{
                return null;
            }
           
        }
        catch (err) {
            return rejectWithValue("Failed to get all product!");
        }
    })

const productSlice = createSlice({
    name: "product",
    initialState: {
        product:null,
    },
    extraReducers: builder => {
        builder
          .addCase(getProduct.pending, (state, action) => {
            state.status = 'loading'
          })
          .addCase(getProduct.fulfilled, (state, action) => {
            state.product=action.payload
            state.status = 'idle'
          }) .addCase(getProduct.rejected, (state, action) => {
            // state.product=action.payload
            state.status = 'failed'
          })
      }
    
})
export default productSlice;

// extraReducers: {
//     [getProduct.fulfilled]: (state, { payload }) => {
//         state.product = payload;
//     },
// }